import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_BONUSES,
  CREATE_BONUS,
  UPDATE_BONUS,
  DELETE_BONUS,
} from "./actionTypes"
import {
  getAllBonusesCall,
  createBonusCall,
  updateBonusCall,
  deleteBonusCall,
  API_URL,
} from "../../helpers/repository"
import { getAllBonuses, getAllBonusesResponseSuccess } from "./actions"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"

function* attemptGetAllBonuses() {
  try {
    const response = yield call(getAllBonusesCall)
    yield put(getAllBonusesResponseSuccess(response.data.bonuses))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateBonus(action) {
  const { history } = action
  try {
    const response = yield call(createBonusCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/promotions/bonuses")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditBonus(action) {
  const { history, redirectTo } = action
  try {
    const response = yield call(updateBonusCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllBonuses())
    history.push(`/promotions/bonuses`)
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeleteBonus(action) {
  try {
    const response = yield call(deleteBonusCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllBonuses())
  } catch (error) {
    showErrorMessages(error)
  }
}

function* BonusesSaga() {
  yield takeEvery(GET_ALL_BONUSES, attemptGetAllBonuses)
  yield takeEvery(CREATE_BONUS, attemptCreateBonus)
  yield takeEvery(UPDATE_BONUS, attemptEditBonus)
  yield takeEvery(DELETE_BONUS, attemptDeleteBonus)
}

export default BonusesSaga
